<template>
	<div class="tpl">
		<mt-header title="选择所在城市">
		  <router-link :to="{name:fromPath.name,params:{add:nowAdd},query:{add:nowAdd}}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <!--<mt-button icon="more" slot="right"></mt-button>-->
		</mt-header>
		<mt-search cancel-text="取消" placeholder="输入你所在的城市"></mt-search>
		
		<div class="add-list">
			<div class="prov-list">
				<ul>
					<li v-for="item in addressInfo.prov" :class="{'active':item.region_id==addressId.prov}" @click="getAddressInfo(item.region_id,'prov','city')">{{item.region_name}}</li>
				</ul>
			</div>
			<div class="city-list-wrap">
				<div class="now-add">
					<p class="list-title">当前位置</p>
					<p class="add-name"><img src="../../assets/img/common/ic_tips_city@2x.png"/>{{nowAdd}}</p>
				</div>
				<!--<div class="search-add">
					<p class="list-title">最近查询</p>
					<span v-for="item in searchAdd" class="list-item">{{item}}</span>
				</div>-->
				<div class="city-list" v-if="addressInfo.city">
					<p class="list-title">热门城市</p>
					<!--<span @click="chooseAllCity" class="list-item">全部</span>-->
					<span v-for="item in addressInfo.city" class="list-item" :class="{'active':item.region_id==addressId.city}" @click="getAddressInfo(item.region_id,'city','',item.region_name)">{{item.region_name}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"choose-add",
		data(){
			return{
				fromPath:"",	//来源路由
				nowAdd:"",
				searchAdd:["苏州","上海"],
				addressInfo:{
					prov:"",
					city:""
				},
				addressId:{
					prov:"",
					city:""
				}
			}
		},
		created(){
			this.$store.commit("changeTabBarShow",false);
			this.nowAdd = this.$route.params.nowAdd;
			console.log(this.nowAdd);
			
			this.getAddressInfo()
		},
		beforeRouteEnter (to, from, next) {
            next((vm)=>{ //参数vm就是当前组件的实例。
                vm.fromPath = from;
                console.log(vm.fromPath)
            })
		},
		methods:{
			getAddressInfo(id=1,thisLevel="prov",nextLevel="prov",name){
				var _this = this;
				this.addressId[thisLevel] = id;
				if(nextLevel!=""){
					this.$axios({
						url:"Currency/getRegionInfoList",
						method:"post",
						data:{
							region_id:id
						}
					}).then(res=>{
						console.log(res);
						this.addressInfo[nextLevel] = res.data.data;
					}).catch(err=>{
						console.log(err)
					})
				}else{
					
					_this.addHasChoosed(id,name);
				}
				
			},
			addHasChoosed(id,cname){
//				this.nowAdd = {
//					id:id,
//					name:cname
//				};
				console.log(id,cname);
				this.$router.push({
					name:this.fromPath.name,
					query:{add:cname},
					params:{add:cname},
				});
			},
			chooseAllCity(){
				this.nowAdd="",
				this.$router.push({name:this.fromPath.name,params:{add:this.nowAdd}})
			}
		}
	}
</script>

<style scoped>
	
	>>>.mint-search{
		height: 100%;
	}
	>>>.mint-searchbar{
		border-radius: 1rem;
		padding: 0.2rem 0.8rem;
		margin: 0.5rem;
		background: rgba(189,189,189,.2);
	}
	>>>.mint-searchbar-cancel{
		color: #d2d2d2;
		font-size: 0;
		width: 1.5rem;
		height: 1.5rem;
		background: url(../../assets/img/common/ic_text_del@2x.png) no-repeat;
		background-size: 100%;
	}
	>>>.mint-searchbar-inner{
		background: none;
	}
	>>>.mint-searchbar-inner .mintui-search{
		color: #ae96f1;
		font-size: 1.2rem;
	}
	>>>.mint-searchbar-inner input{
		background: none;
		color: #282828;
		padding-left: 0.3rem;
	}
	
	
	.add-list{
		display: flex;
		justify-content: flex-start;
		height: 36rem;
		overflow: hidden;
	}
	.add-list .prov-list{
		width: 6rem;
		background: rgba(189,189,189,.2);
		height: 100%;
		overflow-y: scroll;
	}
	.add-list .prov-list li{
		font-size: 0.8rem;
		line-height: 3rem;
		color: #7a7a7a;
		text-align: center;
	}
	.add-list .prov-list li.active{
		background: #fff;
		color: #5415f9;
		font-weight: bold;
	}
	.add-list .city-list-wrap{
		flex: 1;
		padding: 0.6rem;
		height: 100%;
		overflow-y: scroll;
	}
	.add-list .city-list-wrap>div{
		margin-bottom: 0.5rem;
	}
	.add-list .city-list-wrap .list-title{
		color: #9e9e9e;
		font-size: 0.8rem;
		line-height: 1.5rem;
		margin-bottom: 0.5rem;
	}
	.add-list .now-add .add-name{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.9rem;
		color: #282828;
	}
	.add-list .now-add .add-name img{
		width: 1.6rem;
		margin-right: 0.5rem;
	}
	.add-list .list-item{
		font-size: 0.8rem;
	    color: #282828;
	    padding: 0 1rem;
	    background: rgba(210,210,210,.4);
	    margin-right: 1rem;
	    line-height: 1.5rem;
	    display: inline-block;
	    margin-bottom: 1rem;
	    border-radius: 1rem;
	}
	.add-list .list-item.active{
		background: #7644FA;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/ChooseAddress.vue